import React from 'react';
import PropTypes from 'prop-types';
import BasePlayerReport from './BasePlayerReport';

const OpposingBatterReport = ({ match: { path, url, params: { batterId } }, location: { pathname }, playerTeamStartingPitchers, tabs }) => (
    <BasePlayerReport
        tabs={tabs}
        pathname={pathname}
        path={path}
        url={url}
        playerId={batterId}
        playerTeamStartingPitchers={playerTeamStartingPitchers}
    />
);

OpposingBatterReport.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        path: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        params: PropTypes.shape({
            batterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
    }).isRequired,
    playerTeamStartingPitchers: PropTypes.arrayOf(PropTypes.shape({})),
    tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
};
OpposingBatterReport.defaultProps = {
    playerTeamStartingPitchers: undefined,
};

export default OpposingBatterReport;
